import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  payHealthStipend,
  PayHealthStipendRequest,
  PayHealthStipendResponse,
} from 'api/payments'
import { paymentKeys } from './keys'

export function usePayHealthStipendMutation() {
  const queryClient = useQueryClient()
  return useMutation<PayHealthStipendResponse, Error, PayHealthStipendRequest>({
    mutationFn: payHealthStipend,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: paymentKeys.list }),
  })
}
